import styled from "styled-components";

export default styled.span`
    background: rgba(255, 255, 255, 0.15);
    border-radius: 14px;
    padding: 2px 9px;
    color: #9F9F9F;
    margin: .3rem;
    font-size: 12px;
    display: inline-block;

`;